if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.checkCart.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.onePerCustomer = this.dataset.one == "true";
      this.handle = this.dataset.handle;
      this.advice = document.querySelector(".one-per-customer");
      this.proxyAddToCart = this.querySelector('[data-add-to-cart-proxy]');
      this.productInfo = document.querySelector('.product__info-container');
      this.proxyAddToCartLink = this.proxyAddToCart ? this.proxyAddToCart.querySelector('[data-add-to-cart-proxy-link]') : null;
      this.footer = document.querySelector('footer.footer');
      if(this.proxyAddToCart && this.proxyAddToCartLink) {
        document.addEventListener("scroll", this.activateProxyOnScroll.bind(this));
        this.proxyAddToCart.addEventListener('click', this.onProxyClick.bind(this));
      }

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      if(this.onePerCustomer) this.handleButton();
    }

    checkCart(evt){
      evt.preventDefault();
      let found = false;
      fetch('/cart.js')
      .then((response) => response.json())
      .then((data) => {
        for(const item of data.items){
          if(item.handle == this.handle){
            console.log("found item in cart")
            found = true;
          }
        }
        this.canAdd(found)
      });
    }

    canAdd(is_in_cart){
      if(this.onePerCustomer){
        // console.log(is_in_cart);
        if(is_in_cart){
          console.log("non aggiunto");
          this.submitButton.setAttribute('disabled', 'disabled');
          this.advice.classList.add("highlight");
        }
        else{
          console.log("add")
          this.onSubmitHandler();
        }
      }
      else{
        console.log("add");
        this.onSubmitHandler();
      }

    }

    onSubmitHandler() {
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cart.renderContents(response) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        if(this.onePerCustomer) this.handleButton();
      });

    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || document.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        !this.submitButton.classList.contains("error") ? this.submitButton.classList.add("error") : null;
        this.errorMessage.textContent = errorMessage;
      }
    }

    handleButton(){
      fetch('/cart.js')
      .then((response) => response.json())
      .then((data) => {
        for(const item of data.items){
          if(item.handle == this.handle){
            this.submitButton.setAttribute('disabled', 'disabled');
            this.advice.classList.add("highlight");
          }
        }
        this.submitButton.closest('.product-form').classList.remove("hidden");
      });
    }


    onProxyClick(evt) {
      evt.preventDefault();
      var pInfo = this.productInfo;
      if(pInfo) {
        pInfo.scrollIntoView({ behaviour: 'smooth' });
      }
    }

    activateProxyOnScroll(evt) {
      if(this.productInfo) {
        if(window.scrollY > (this.productInfo.offsetTop + this.productInfo.offsetHeight)) {
          this.proxyAddToCart.classList.add('active');

          /* if((window.scrollY + window.innerHeight) > (this.footer.offsetTop)) {
            this.proxyAddToCart.classList.remove('active');
          } else {
            this.proxyAddToCart.classList.add('active');
          } */
        } else {
          this.proxyAddToCart.classList.remove('active');
        }
      }
    }
  });
}
